import { observer } from "mobx-react-lite";
import React from "react";
import { View } from "tamagui";
import { Body } from "../../../ui/Body";
import { Button } from "../../../ui/Button";
import { Group } from "../../../ui/Group";
import type { TrackerHistoryItem } from "../data/TrackerUserData";
import type TrackerModuleModel from "../TrackerModuleModel";
import { HistoryItemRow } from "./HistoryItemRow";

const STEP_AMOUNT = 5;

export const TrackerHistoryList: React.FC<{
  module: TrackerModuleModel;
  showEdit: boolean;
  history?: TrackerHistoryItem[];
  initialAmount?: number;
}> = observer(({ module, showEdit, history, initialAmount }) => {
  const [showAmount, setShowAmount] = React.useState(
    initialAmount ?? STEP_AMOUNT,
  );

  if (!history) {
    return null;
  }

  const items = history.slice().reverse().slice(0, showAmount);

  const showMoreButton = showAmount < history.length;

  const itemsLeftLabel: string = `Show more (${history.length - items.length})`;

  return (
    <>
      {items ? (
        <>
          <Group borderTop={true}>
            {items.map((entry) => (
              <HistoryItemRow
                key={entry.ts}
                entry={entry}
                module={module}
                showEdit={showEdit}
              />
            ))}
          </Group>
          {showMoreButton && (
            <View marginTop="$medium">
              <Button
                type="secondary"
                onPress={() => {
                  setShowAmount(showAmount + STEP_AMOUNT);
                }}
              >
                {itemsLeftLabel}
              </Button>
            </View>
          )}
        </>
      ) : (
        <Body>No entries added yet</Body>
      )}
    </>
  );
});
